const toggle = document.querySelector<HTMLButtonElement>('.nav-toggle');
const navList = document.querySelector<HTMLUListElement>('#main-nav-list');

if (toggle && navList) {
    toggle.addEventListener('click', () => {
        const open = navList.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', String(open));
    });

    // Close on outside click
    document.addEventListener('click', (e) => {
        if (!toggle.contains(e.target as Node) && !navList.contains(e.target as Node)) {
            navList.classList.remove('is-open');
            toggle.setAttribute('aria-expanded', 'false');
        }
    });
}
